import clsx from "clsx";
import translate from "../locales";
import { Page } from "./page";

export function ExercisePage({
  title = "",
  description = "",
  labelPrevious = "exercise.ui.button-previous",
  labelNext = "exercise.ui.button-next",
  onPrevious,
  onNext,
  buttonNextDisabled = false,
  children,
  showSources = false,
}) {
  return (
    <Page className="exercise-page">
      <div className={clsx("page__content page__content--padded")}>
        <div className={clsx("flex-box", "flex-box_heading")}>
          <div>
            <h1 className={clsx("text_title")}>{translate(title)}</h1>
            <p className={clsx("text_description")}>{translate(description)}</p>
          </div>
          {showSources && (
            <a
              className={clsx(
                "button",
                "button--outline",
                "sources",
                "sources_link-mobile",
              )}
              target="_blank"
              href={translate("info-sources.source-material.url")}
              rel="noreferrer"
            >
              {translate("exercise.ui.button-source")}
            </a>
          )}
        </div>

        {children}

        <div
          className={clsx(
            "flex-box",
            "flex-box_spacebetween",
            "flex-box_navigation",
          )}
        >
          {onPrevious && (
            <button
              className={clsx("button", "button--outline")}
              onClick={onPrevious}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <mask
                  id="mask0_200_466"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="25"
                  height="25"
                >
                  <rect
                    x="24.0586"
                    y="24.8915"
                    width="24"
                    height="24"
                    transform="rotate(-180 24.0586 24.8915)"
                    fill="#D9D9D9"
                  />
                </mask>
                <g mask="url(#mask0_200_466)">
                  <path
                    d="M10.0586 6.89148L11.4586 8.34148L7.90859 11.8915L20.0586 11.8915L20.0586 13.8915L7.90859 13.8915L11.4586 17.4415L10.0586 18.8915L4.05859 12.8915L10.0586 6.89148Z"
                    fill="#002B6C"
                  />
                </g>
              </svg>
              {translate(labelPrevious)}
            </button>
          )}

          {onNext && (
            <button
              disabled={buttonNextDisabled}
              className={clsx("button")}
              onClick={onNext}
            >
              {translate(labelNext)}
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <mask
                  id="mask0_200_459"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="25"
                  height="25"
                >
                  <rect
                    x="0.0585938"
                    y="0.891479"
                    width="24"
                    height="24"
                    fill="#D9D9D9"
                  />
                </mask>
                <g mask="url(#mask0_200_459)">
                  <path
                    d="M14.0586 18.8915L12.6586 17.4415L16.2086 13.8915H4.05859V11.8915H16.2086L12.6586 8.34148L14.0586 6.89148L20.0586 12.8915L14.0586 18.8915Z"
                    fill="white"
                  />
                </g>
              </svg>
            </button>
          )}
        </div>
      </div>
    </Page>
  );
}
